import { render, staticRenderFns } from "./PromiseIcon.vue?vue&type=template&id=591d39b4&"
import script from "./PromiseIcon.vue?vue&type=script&lang=js&"
export * from "./PromiseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports